import React, { useRef, useEffect } from 'react';

export function DebouncedInput({ value, onValueChange, className, type = "text", as = "input", ...props }) {
  const inputRef = useRef(null);
  const timeoutRef = useRef(null);

  // Sync value from parent IF the input doesn't have focus.
  // This ensures that when the user switches to a different business/item, 
  // the input updates to show the correct data.
  useEffect(() => {
    if (inputRef.current && document.activeElement !== inputRef.current) {
      inputRef.current.value = value ?? '';
    }
  }, [value]);

  const handleChange = (e) => {
    const val = e.target.value;
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      if (onValueChange) onValueChange(val);
    }, 300);
  };

  const handleBlur = (e) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    if (onValueChange) onValueChange(e.target.value);
    if (props.onBlur) props.onBlur(e);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (onValueChange) onValueChange(e.target.value);
    }
    if (props.onKeyDown) props.onKeyDown(e);
  };

  if (as === "textarea") {
    return (
      <textarea
        ref={inputRef}
        defaultValue={value ?? ''}
        className={className}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        {...props}
      />
    );
  }

  return (
    <input
      ref={inputRef}
      defaultValue={value ?? ''}
      type={type}
      className={className}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      {...props}
    />
  );
}
